import * as d3 from "d3";

export function barchart2() {
  var margin = { top: 20, left: 75, bottom: 50, right: 50 },
    width = 1000 - margin.left - margin.right,
    height = 350 - margin.top - margin.bottom;
  var svg = d3
    .select("#chart1")
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform", "translate(" + margin.left + ", " + margin.top + ")");

  var x = d3.scaleBand();
  var y = d3.scaleLinear();

  var delay = function(d, i) {
    return i * 50;
  };

  var dataset;
  var xAxis;
  var all, topfive, bottomfive;
  var current, sortMode, filterMode;
  var CO2, NO2;
  d3.json("data/emission.json", d => {
    return {
      name: d.name,
      NO2_count: +d.NO2,
      CO2_count: +d.CO2
    };
  }).then(data => {
    dataset = data;

    CO2 = dataset.map(function(x) {
      return { name: x.year, count: x.CO2 };
    });
    NO2 = dataset.map(function(x) {
      return { name: x.year, count: x.NO2 };
    });
    //        // console.log(dataset);
    // console.log(CO2);
    //        // console.log(NO2);
    dataset.sort(function(a, b) {
      return d3.ascending(a.count, b.count);
    });
    filter("#CO2");
    toggleFilter("#CO2");
    draw();
  });

  d3.select("#NO2").on("click", () => {
    filter("#NO2");
    toggleFilter("#NO2");
    redraw();
  });

  d3.select("#CO2").on("click", () => {
    filter("#CO2");
    toggleFilter("#CO2");
    redraw();
  });

  //    d3.select('input')
  //        .on('change', () => {
  //            sort(sortMode);
  //            toggle(sortMode);
  //            redraw();
  //        });

  function transition() {
    var transition = svg.transition().duration(750);

    transition
      .selectAll(".bar")
      .delay(delay)
      .attr("x", d => x(d.name));

    transition
      .selectAll(".name")
      .delay(delay)
      .attr("x", d => x(d.name) + x.bandwidth() / 2);
  }

  function toggle(id) {
    d3.selectAll(".sort").style("background-color", "#ddd");
    d3.select(id).style("background-color", "#e25a0077");
  }

  function sort(mode) {
    if (mode === "#reset") {
      current.sort((a, b) => d3.ascending(a.name, b.name));
    } else if (mode === "#value") {
      current.sort((a, b) => d3.ascending(a.value, b.value));
    } else if (mode === "#count") {
      current.sort((a, b) => d3.ascending(a.count, b.count));
    } else if (mode === "#orderAsending") {
      current.sort((a, b) => d3.ascending(a.value, b.value));
    } else if (mode === "#orderDesending") {
      current.sort((a, b) => d3.descending(a.value, b.value));
    } else if (mode === "#orderByName") {
      current.sort((a, b) => d3.ascending(a.name, b.name));
    }

    x.domain(current.map(d => d.name));
    sortMode = mode;
  }

  function filter(mode) {
    if (mode === "#NO2") {
      current = JSON.parse(JSON.stringify(NO2));
    } else if (mode === "#CO2") {
      current = JSON.parse(JSON.stringify(CO2));
    }
    filterMode = mode;
  }

  function toggleFilter(id) {
    d3.selectAll(".filter").style("background-color", "#ddd");
    d3.select(id).style("background-color", "lightblue");
  }

  function draw() {
    x.domain(current.map(d => d.name))
      .range([0, width])
      .paddingInner(0.2);

    y.domain([0, d3.max(current, d => d.count)]).range([height, 0]);

    svg
      .selectAll(".bar")
      .data(current, d => d.name)
      .enter()
      .append("rect")
      .attr("class", "bar")
      .attr("x", d => x(d.name))
      .attr("y", d => y(d.count))
      .attr("width", x.bandwidth())
      .attr("height", d => height - y(d.count));

    svg
      .selectAll(".name")
      .data(current, d => d.name)
      .enter()
      .append("text")
      .text(d => d.name)
      .attr("class", "name")
      .attr("style", d => (d.name === "EARTH" ? "fill: red" : ""))
      .attr("x", d => x(d.name) + x.bandwidth() / 2)
      .attr("y", d => y(d.count) + (height - y(d.count)) / 2);

    var xAxis;
    xAxis = d3
      .axisBottom()
      .scale(x)
      .ticks(0)
      .tickSize(0)
      .tickFormat("");

    svg
      .append("g")
      .attr("class", "axis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis);

    svg
      .append("text")
      .attr("class", "xlabel")
      .attr("x", 30)
      .attr("y", height + 20);

    svg
      .append("text")
      .attr("class", "title")
      .text("The CO2 and NO2 concentration over the years")
      .attr("x", 300)
      .attr("y", 1);

    svg
      .append("text")
      .attr("class", "xlabel")
      .attr("x", width - 30)
      .attr("y", height + 20);

    var yAxis = d3
      .axisLeft()
      .scale(y)
      .ticks(5, "d");

    svg
      .append("g")
      .attr("class", "axis")
      .call(yAxis);

    svg
      .append("text")
      .attr("x", -height / 2)
      .attr("y", -margin.left * 0.7)
      .attr("transform", "rotate(-90)")
      .attr("class", "ylabel")
      .append("tspan")
      .text("ppmv(parts per million by volumn)")
      .style("baseline-shift", "super")
      .style("font-size", "0.7em");
  }
  function redraw() {
    // console.log(current);

    //        x.domain(current.map(d => d.name))
    //            .range([0, width])
    //            .paddingInner(0.2);
    //
    //        y.domain([0, d3.max(current, d => d.count)])
    //            .range([height, 0]);
    x.domain(current.map(d => d.name));
    // DATA JOIN FOR BARS.
    var bars = svg.selectAll(".bar").data(current, d => d.name);

    bars
      .transition()
      .duration(750)
      .delay(delay)
      .attr("x", d => x(d.name))
      .attr("y", d => y(0))
      .attr("class", "bar") //🚧  explain
      .attr("x", d => x(d.name)) //🚧  explain
      .attr("y", d => y(d.count))
      .attr("width", x.bandwidth())
      .attr("height", d => height - y(d.count));

    // ENTER.
    //        bars.enter()
    //            .append('rect')
    //            .attr('x', d => x(d.name))  //🚧  explain
    //            .attr('y', d => y(0))  //🚧  explain
    //            .attr('width', x.bandwidth())  //🚧  explain
    //            .transition()  //🚧  explain
    //            .duration(750)  //🚧  explain
    //            .attr('class', 'bar')  //🚧  explain
    //            .attr('x', d => x(d.name))  //🚧  explain
    //            .attr('y', d => y(d.count))  //🚧  explain
    //            .attr('width', x.bandwidth())  //🚧  explain
    //            .attr('height', d => height - y(d.count));  //🚧  explain

    // EXIT.
    bars
      .exit()
      .transition() //🚧  explain
      .duration(750) //🚧  explain
      .style("opacity", 0) //🚧  explain
      .remove(); //🚧  explain

    ////////////////////////////////
    // DATA JOIN FOR NAMES.
    var name = svg.selectAll(".name").data(current, d => d.name);

    // UPDATE.
    name
      .transition()
      .duration(750)
      .delay(delay)
      .attr("x", (d, i) => x(d.name) + x.bandwidth() / 2);

    // ENTER.
    name
      .enter()
      .append("text")
      .attr("x", d => x(d.name) + x.bandwidth() / 2)
      .attr("y", d => y(d.count) + (height - y(d.count)) / 2)
      .style("opacity", 0)
      .transition()
      .duration(1000)
      .text(d => d.name)
      .attr("class", "name")
      .attr("style", d => (d.name === "EARTH" ? "fill: red" : ""))
      .attr("x", d => x(d.name) + x.bandwidth() / 2)
      .attr("y", d => y(d.count) + (height - y(d.count)) / 2)
      .style("opacity", 1);

    // EXIT.
    name
      .exit()
      .transition()
      .duration(750)
      .style("opacity", 0)
      .remove();
  }
}
